import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_46: FaireProductEntity = {
  token: "legacy_prod_abbott-46",
  type: "product",
  name: 'Mini Bowl White 4" D (Clearance)',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d37b1372053864c50ccf73da576fb8449dc108e401325f238dd28a4aa68901db.jpeg",
  priceDollars: 6,
  msrpDollars: 12,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
